export const providerTypes = ['jotform', 'typeform'] as const;
// Toggle currently enabled providers without removing underlying provider support.
// Re-enable Typeform by adding it to this array.
export const activeProviderTypes = ['jotform'] as const;
export const languageOptions = ['NL', 'FR', 'EN'] as const;
export const targetGroupTypes = ['primary', 'secondary'] as const;

export type Provider = (typeof providerTypes)[number];
export type ActiveProvider = (typeof activeProviderTypes)[number];
export type Language = (typeof languageOptions)[number];
export type TargetGroupType = (typeof targetGroupTypes)[number];
